import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import * as React from 'react';
import { GridItem } from '@verclam/grid-system';
import { Button } from '@verclam/ui-kit';

type Props = {
	readonly index: number;
	readonly label: string;
	readonly isRemovable: boolean;
	readonly onRemove: (index: number) => void;
};

/** One option of a choice field, with the way to remove it when allowed. Renders the two grid cells of its row. */
const OptionRow: React.FC<Props> = ({ index, label, isRemovable, onRemove }) => {
	const handleRemoveClick = React.useCallback(() => {
		onRemove(index);
	}, [onRemove, index]);

	return (
		<React.Fragment>
			<GridItem columnSize={{ xs: 9, xl: 9 }}>
				<span>{label}</span>
			</GridItem>
			<GridItem columnSize={{ xs: 3, xl: 3 }}>
				<ConditionalLoader data={isRemovable}>
					<Button
						type="button"
						size="sm"
						severity="secondary"
						label="Retirer"
						onClick={handleRemoveClick}
					/>
				</ConditionalLoader>
			</GridItem>
		</React.Fragment>
	);
};

export default OptionRow;
